import { orderSections } from '@/components/views/DynamicPageView/config/shared/orderSections';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, APP_ROLES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_ORDER: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.ORDER,
  showIfAllowedProduct: ApplicationType.ORDER,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'ORDER_DETAIL',
      widgets: [
        { id: WIDGETS.LOAN_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
        { id: WIDGETS.LOAN_PARTICIPANT_SOURCE_WIDGET, roles: [...ALL_CORE_APP_ROLES], props: {} },
        {
          id: WIDGETS.LOAN_DETAIL_ACTIONS,
          roles: [
            APP_ROLES.ADMIN,
            APP_ROLES.SUPER_ADMIN,
            APP_ROLES.MERCHANT,
            APP_ROLES.CHANNEL,
            APP_ROLES.AGENT,
            APP_ROLES.CPC_BACK_OFFICE,
          ],
          props: {},
        },
        {
          id: WIDGETS.LOAN_PRODUCT_TYPE_REDIRECT,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
          notShownInRightMenu: true,
        },
        {
          id: WIDGETS.LOAN_HIGHLIGHTS,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
        },
      ],
    },
  ],
  sections: orderSections,
};
